import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

export default function Datenschutz() {
  const { t } = useLanguage();
  const d = t.legal.datenschutz;

  return (
    <div data-testid="datenschutz-page">
      <PageHeader overline="Legal" title={t.legal.datenschutzTitle} subtitle={d.intro} />
      <section className="bg-white">
        <div className="mx-auto max-w-3xl space-y-10 px-6 py-20 lg:px-10 lg:py-24">
          {d.sections.map((s, i) => (
            <Reveal key={i}>
              <h2 className="text-xl font-semibold tracking-tight text-[#0A0A0A]">{s.h}</h2>
              <p className="mt-3 leading-relaxed text-[#4A4A4A]">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
